import React from "react";
import { Col, Tooltip } from "antd";
import moment from "moment";
import  PropTypes from 'prop-types';
import { withRouter } from "react-router";
import TitleNode from "../../../../../CommonComponents/CustomNodes/TitleNode/TitleNode";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import pencil from "../../../../../assets/icons/edit.svg";
import history from "../../../../../history/history";
import { columnsInto, columnsFrom } from "./ReviewConfig";
import { dollarText, unitText, pricePerUnitText, replaceSelect } from "../../../../../utils/replacer";
import FlowCard from "../../../../../CommonComponents/FlowCard/FlowCard";
import Buttons from "./Buttons";
import PopUp from "./PopUp";
import { initiateTracking, moveIntoErrorPosition, recordError } from "../../../../../utils/commonUtil";
import { DataHeading, DataValue, DisplayFlex, CustomCheckbox, ErrorMsg } from "../../../../../CommonComponents/commonStyles";
import {
  getPrimaryAccount,
  getAccountData,
  isGeminiUser
} from "../../../../../utils/sessionUtil";
import {
  ExchangeFromTable,
  Divider,
  Column,
  Row,
  Flex,
  DesktopView,
  MobileView,
  BoldLabel,
  Title,
  PoolNameReview,
  UnderlyingContent
} from "./styles";
import { checkCSRBusinessFunction } from "../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../CSR/utils/csrBusinessFunctionMapper";
import { CapsuleButton } from "../../../../../CommonComponents/Commons/commonComponents";

class Review extends React.Component {
  state = {
    agreed: false,
    exitPopUp: false,
    stepNum: null,
    isCheckBoxDirty: false,
    geminiAccess:true
  };

  componentDidMount() {
    this.props.getTiffDisclaimer({
      method: "GET",
      url: `/disclaimers?Page=Tiff Review And Submit`,
      isExternal: true
    });
    window.scrollTo(0, 0);
    if(isGeminiUser() && checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_SUBMIT_AN_EXCHANGE_FULL_ACCESS'], this.props.csrBusinessFunction)){
      this.setState({geminiAccess: false})
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitTransactionId) {
      nextProps.selectedTiffOption == "exchangeintoTIFF"
        ? history.push({
          pathname: `/view-edit-tiff-into/${
            nextProps.submitTransactionId
            }/confirmation`
        })
        : history.push({
          pathname: `/view-edit-tiff-from/${
            nextProps.submitTransactionId
            }/confirmation`
        });
    }
  }


  validationCheck = () => {
    if(this.state.agreed) {
      return true
    } else {
      this.setState({isCheckBoxDirty: true})
      setTimeout(() => {
        moveIntoErrorPosition(".error-fields");
      });
      return false
    }
  }

  submit = (e) => {
    if(this.validationCheck()){
      var finalData = {};
      var fromData = [];
      var toData = [];
      if (this.props.selectedTiffOption == "exchangeintoTIFF") {
        this.props.poolDataInto &&
          this.props.poolDataInto.exchangeIntoPoolData.map(data => {
            this.props.tiffFormInfo.exchangeFrom.map(item => {
              if (data.poolId == item.poolId) {
                fromData.push({
                  ...data,
                  currentDollarValue: item.currentDollarValue,
                  currentShares: item.currentShares,
                  currentPricePerShare: item.currentPricePerShare,
                  currentAllocPercent: item.currentAllocPercent
                });
              }
            });
          });
        finalData = {
          totalExchangeAmount: this.props.poolDataInto.totalAmountIntoPool,
          exchangeFrom: fromData,
          exchangeTo: this.props.toTiffPoolDetails
        };
      } else {
        this.props.poolDataFrom &&
          this.props.poolDataFrom.exchangeFromPoolData.map(data => {
            this.props.tiffFormInfo.exchangeTo.map(item => {
              if (data.poolId == item.poolId) {
                toData.push({
                  ...data,
                  currentDollarValue: item.currentDollarValue,
                  currentShares: item.currentShares,
                  currentPricePerShare: item.currentPricePerShare,
                  currentAllocPercent: item.currentAllocPercent
                });
              }
            });
          });

        const exchangeFrom = this.props.fromTiffPoolDetails;
        if (exchangeFrom) { exchangeFrom[0].value = this.props.poolDataInto.valueTiffExchangeAmount; }
        finalData = {
          totalExchangeAmount: this.props.poolDataInto.valueTiffExchangeAmount,
          exchangeFrom: exchangeFrom,
          exchangeTo: toData
        };
      }
      this.props.submitTiffForm({
        method: "PUT",
        url: `/donor-portal/api/exchange/${
          getPrimaryAccount().userId
          }/saveTiffExchange`,
        data: {
          accountId: getPrimaryAccount().userId,
          codeId: this.props.tiffFormInfo.codeId,
          acctAdvisorPartyId: getAccountData().partyId,
          startDate: moment()
            .format("x")
            .toString(),
          exchangeType: "TIFF Exchange",
          exchangeScheduledDate: moment(
            this.props.expectedEchangeDate[0].field_date
          )
            .valueOf()
            .toString(),
          exchangeFromUnit: "DOLLAR",
          totalExchangeAmount: finalData.totalExchangeAmount,
          exchangeFrom: finalData.exchangeFrom,
          exchangeTo: finalData.exchangeTo
        },
        selectedTiffOption: this.props.selectedTiffOption
      });
    }
  };

  stepOne = (key, section) => {
    try {
      initiateTracking('edit', 'Recommend an Exchange', `Step ${key} Review exchange and submit - ${section}`, `Edit - TIFF Exchange ${key === "2" ? "INTO" : "FROM"} - Body`);
      this.props.history.push({
        pathname: `/investments/recommend-an-exchange-tiff`,
        params: { type: "reviewEdit" }
      });
    } catch (error) {
      recordError(error);
    }
  };

  stepTwo = (key, section) => {
    try {
      initiateTracking('edit', 'Recommend an Exchange', `Step ${key} Review exchange and submit - ${section}`, `Edit - TIFF Exchange ${key === "2" ? "INTO" : "FROM"} - Body`);
      this.props.history.push({
        pathname: `/investments/recommend-an-exchange-tiff/allocate`,
        params: { type: "reviewEdit" }
      });
    } catch (error) {
      recordError(error);
    }
  };

  calculateFee = value => {
    const { selectedTiffOption, customFeeForPool = []  } = this.props;
    let feePercentage = 0;
    if(customFeeForPool.length) {
      for(let i= 0; i<= customFeeForPool.length; i++) {
        if(selectedTiffOption === "exchangeintoTIFF" && customFeeForPool[i].feeType === "TO_TIFF") {
          feePercentage = customFeeForPool[i].feePercent;
          break;
        } else  {
          if(customFeeForPool[i].feeType === "FROM_TIFF") {
            feePercentage = customFeeForPool[i].feePercent;
            break;
          } else {
            feePercentage = 0;
          }
        }
      }
    }
 
    const num = parseFloat(value);
    return ((num * feePercentage) / 100).toFixed(2);
  };

  checked = value => {
    if (isGeminiUser() && value) {
      value = !checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_SUBMIT_AN_EXCHANGE_FULL_ACCESS'], this.props.csrBusinessFunction)
    }
    this.setState({ agreed: value,  isCheckBoxDirty: value });
  };

  styleConfig = () => {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardDivider: true,
      cardPadding: true
    };
  };

  renderTitleGrid = pool => {
    return <PoolNameReview>{replaceSelect(pool.poolName)}</PoolNameReview>;
  };

  renderFixGrid = ({ pool, gridName }) => {
    switch (gridName) {
      case "availableBalance": {
        return (
          <>
            <TitleNode title={gridName} />
            <DataValue>{dollarText(pool[gridName])}</DataValue>
          </>
        );
      }
      case "availableUnits": {
        return (
          <>
            <TitleNode title={gridName} />
            <DataValue>{unitText(pool[gridName])}</DataValue>
          </>
        );
      }
      case "pricePerUnit": {
        const perUpdatedOn = 'Price updated on ' + moment(moment.tz(pool.dateOfPricePerUnit, 'America/New_York')).format('MM/DD/YYYY')
        return (
          <>
            <TitleNode title={gridName} />
            <Tooltip placement="bottomLeft" title={perUpdatedOn}>
              <UnderlyingContent>
                {pricePerUnitText(pool[gridName], pool.isRise)}
              </UnderlyingContent>
            </Tooltip>
          </>
        );
      }
      case "dollars": {
        return (
          <>
            <TitleNode title={gridName} />
            <DataValue> {dollarText(pool.value)} </DataValue>
          </>
        );
      }
      case "percentage": {
        let per = Number(pool.value).toFixed(2);
        return (
          <>
            <TitleNode title={gridName} />
            <DataValue> {per} %</DataValue>
          </>
        );
      }
    }
  };

  destPoolDataInto = (pool, index) => {
    return [
      {
        name: "poolName",
        gridWidth: "100",
        type: "TitleGrid",
        render: this.renderTitleGrid(pool),
        noBorderBottom: true,
        ptop: true,
        pbottom: true
      },
      {
        name: "availableBalance",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "availableBalance" }),
        ptop: false,
        pbottom: true
      },
      {
        name: "availableUnits",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "availableUnits" }),
        ptop: false,
        pbottom: true
      },
      {
        name: "pricePerUnit",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "pricePerUnit" }),
        ptop: true,
        pbottom: true
      },
      {
        name: "Dollars",
        type: "FixGrid",
        gridWidth: "50",
        render: this.renderFixGrid({ pool, gridName: "dollars" }),
        ptop: true,
        pbottom: true
      }
    ];
  };

  destPoolDataFrom = (pool, index) => {
    return [
      {
        name: "poolName",
        gridWidth: "100",
        type: "TitleGrid",
        render: this.renderTitleGrid(pool),
        noBorderBottom: true,
        ptop: true,
        pbottom: true
      },
      {
        name: "availableBalance",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "availableBalance" }),
        ptop: false,
        pbottom: true
      },
      {
        name: "availableUnits",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "availableUnits" }),
        ptop: false,
        pbottom: true
      },
      {
        name: "pricePerUnit",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "pricePerUnit" }),
        ptop: true,
        pbottom: true
      },
      {
        name: "Percentage",
        type: "FixGrid",
        gridWidth: "50",
        render: this.renderFixGrid({ pool, gridName: "percentage" }),
        ptop: true,
        pbottom: true
      }
    ];
  };

  backStep = step => {
    try {
      if (step === "one") {
        initiateTracking('back', 'Recommend an Exchange', 'Step 2 Review exchange and submit', `Back - TIFF Exchange INTO`);
        this.props.history.push({
          pathname: `/investments/recommend-an-exchange-tiff`
        });
      } else if (step === "two") {
        initiateTracking('back', 'Recommend an Exchange', 'Step 3 Review exchange and submit', `Back - TIFF Exchange FROM`);
        this.props.history.push({
          pathname: `/investments/recommend-an-exchange-tiff/allocate`
        });
      }
    } catch (error) {
      recordError(error);
    }
  };

  onExitClick = (stepNum) => {
    this.setState({ exitPopUp: true, stepNum });
  };
  exitFlow = () => {
    initiateTracking('exit', 'Recommend an Exchange', `Step ${this.state.stepNum} Review exchange and submit`, `Exit - TIFF Exchange ${this.state.stepNum === "2" ? "INTO" : "FROM"}`);
    this.props.history.push("/investments/recommend-an-exchange-tiff");
    this.props.resetFlow();
    this.setState({ exitPopUp: false });
  };
  stayOnFlow = () => {
    this.setState({ exitPopUp: false });
  };

  destObj() {
    return [
      {
        name: "pool",
        gridWidth: "50",
        type: "FixGrid",
        render: (
          <>
            <DataHeading>Schedule type</DataHeading>
            <DataValue className="mt-05">TIFF Exchange</DataValue>
          </>
        ),
        noBorderBottom: true,
        ptop: true,
        pbottom: false
      },
      {
        name: "value",
        gridWidth: "50",
        type: "FixGrid",
        render: (
          <>
            <DataHeading>Exchange type</DataHeading>
            {this.props.selectedTiffOption === "exchangeintoTIFF" ? (
              <DataValue className="mt-05">Exchange into TIFF</DataValue>
            ) : (
                <DataValue className="mt-05">Exchange from TIFF</DataValue>
              )}
          </>
        ),
        ptop: true,
        pbottom: false
      }
    ];
  }

  styleConfigTop() {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardPadding: false
    };
  }
  render() {
    return (
      <>
        <Flex>
          <Title className="mr-05">Investment option exchange</Title>
          <CapsuleButton data-test="data-Edit" height="23px"  iconType="edit" text="Edit" onClick={() => this.stepOne(this.props.selectedTiffOption === "exchangeintoTIFF" ? "2" : "3", "Investment option exchange")}/>
        </Flex>
        <Row>
          <Col lg={24} md={24} xs={0}>
            <DisplayFlex className="mt-30">
              <Column>
                <DataHeading>Schedule type</DataHeading>
                <DataValue className="mt-05">TIFF Exchange</DataValue>
              </Column>
              <Column>
                <DataHeading>Exchange type</DataHeading>
                {this.props.selectedTiffOption === "exchangeintoTIFF" ? (
                  <DataValue className="mt-05">Exchange into TIFF</DataValue>
                ) : (
                    <DataValue className="mt-05">Exchange from TIFF</DataValue>
                  )}
              </Column>
            </DisplayFlex>
          </Col>
          <Col lg={0} md={0} xs={24}>
            <FlowCard
              cardConfig={this.destObj()}
              styleConfig={this.styleConfigTop()}
            />
          </Col>
        </Row>
        <Divider />

        <Flex>
          <Title className="mr-05">Amount to be exchanged {this.props.selectedTiffOption === "exchangeintoTIFF" ? "to" : "from"} TIFF</Title>
          {!this.props.poolDataInto.totalAmountIntoPool && <CapsuleButton height="23px"  iconType="edit" text="Edit" data-test="data-Edit2" onClick={() => this.stepOne("3", "Amount to be exchanged from TIFF")}/>}
        </Flex>
        <DataHeading className="mt-30 mt-xs-20">Exchange Amount</DataHeading>
        <DataValue className="mt-05">{dollarText(this.props.poolDataInto.valueTiffExchangeAmount || this.props.poolDataInto.totalAmountIntoPool)}</DataValue>
        <Divider />

        {this.props.selectedTiffOption === "exchangeintoTIFF" ? (
          <>
            <Flex className="mb-30">
              <Title className="mr-05">Recommend exchange from</Title>
              <CapsuleButton height="23px" iconType="edit" text="Edit" onClick={() => this.stepOne("2", "Recommend exchange from")}/>
            </Flex>
            <DesktopView>
              <ExchangeFromTable
                pagination={false}
                style={{ width: "100%" }}
                columns={columnsInto}
                dataSource={this.props.poolDataInto.exchangeIntoPoolData}
                locale={{ emptyText: "Please Wait..." }}
              />
            </DesktopView>
            <MobileView>
              {this.props.poolDataInto.exchangeIntoPoolData.map(
                (pool, index) => {
                  return (
                    <FlowCard
                      cardConfig={this.destPoolDataInto(pool, index)}
                      styleConfig={this.styleConfig()}
                      index={index}
                      key={index}
                      scrollId="fromFlowCard"
                    />
                  );
                }
              )}
            </MobileView>
          </>
        ) : (
            <>
              <Flex className="mb-30">
                <Title className="mr-05">Recommend exchange to</Title>
                <CapsuleButton height="23px" iconType="edit" text="Edit" onClick={() => this.stepTwo("3", "Recommend exchange to")}/>
              </Flex>
              <DesktopView>
                <ExchangeFromTable
                  pagination={false}
                  style={{ width: "100%" }}
                  columns={columnsFrom}
                  dataSource={this.props.poolDataFrom.exchangeFromPoolData}
                  locale={{ emptyText: "Please Wait..." }}
                />
              </DesktopView>
              <MobileView>
                {this.props.poolDataFrom.exchangeFromPoolData && this.props.poolDataFrom.exchangeFromPoolData.map(
                  (pool, index) => {
                    return (
                      <FlowCard
                        cardConfig={this.destPoolDataFrom(pool, index)}
                        styleConfig={this.styleConfig()}
                        index={index}
                        key={index}
                        scrollId="fromFlowCard"
                      />
                    );
                  }
                )}
              </MobileView>
            </>
          )}

        <BoldLabel>
          Applicable fee amount: $
          {this.props.selectedTiffOption === "exchangeintoTIFF"
            ? this.calculateFee(this.props.poolDataInto.totalAmountIntoPool)
            : this.calculateFee(
              this.props.poolDataInto.valueTiffExchangeAmount
            )}
        </BoldLabel>
        <Divider className="mt-xs-20" />
        {this.props.tiffDisclaimer ? <DataHeading dangerouslySetInnerHTML={{ __html: this.props.tiffDisclaimer }} /> : <Preloader styling="w25" />}
        <Divider />
        <Row>
          <CustomCheckbox
            aria-label="checkbox input"
            onChange={e => {
              this.checked(e.target.checked);
            }}
          >
          </CustomCheckbox>
          <DataHeading className="ml-05">
            By checking this box and clicking Submit you certify on behalf of all authorized parties on this account that the information above is correct. You also certify that you have read and agree to Vanguard Charitable's Policies and Guidelines booklet.
          </DataHeading>
        </Row>
        <ErrorMsg visible={!(this.state.isCheckBoxDirty && !this.state.agreed) && "hidden"}>Please check the box to proceed</ErrorMsg>
        <Divider />
        {this.props.selectedTiffOption === "exchangeintoTIFF" ? (
          <Buttons
            type={3}
            opacity="1"
            width={props => props.theme.buttonWidth.primaryButton}
            onClickSubmit={this.submit}
            disabled= {!this.state.geminiAccess}
            onClickBack={() => this.backStep("one")}
            onClickExit={() => this.onExitClick(2)}
          />
        ) : (
            <Buttons
              type={3}
              opacity="1"
              width={props => props.theme.buttonWidth.primaryButton}
              onClickSubmit={this.submit}
              disabled= {!this.state.geminiAccess}
              onClickBack={() => this.backStep("two")}
              onClickExit={() => this.onExitClick(3)}
            />
          )}
        <PopUp
          type="EXIT"
          visible={this.state.exitPopUp}
          onOk={this.exitFlow}
          onCancel={this.stayOnFlow}
        />
      </>
    );
  }
}

Review.propTypes = {
  selectedTiffOption: PropTypes.string,
  poolDataInto: PropTypes.object,
  poolDataFrom: PropTypes.object,
  tiffFormInfo: PropTypes.object,
  getTiffDisclaimer: PropTypes.func,
  submitTransactionId: PropTypes.string,
  fromTiffPoolDetails: PropTypes.array
}

export default withRouter(Review);
